const EnumPrioridadePrestador = {
    PREFERENCIAL: 'Preferencial',
    SEGUNDA_OPCAO: 'Segunda opção',
    OUTROS: 'Outros prestadores'
};

export default EnumPrioridadePrestador;
